import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Label} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../../reducers/common/localization";

class RejectAccreditationRequestsByGroupModal extends Component {
    render() {
        return (
            <Modal className="accreditation-requests-modal" isOpen={this.props.isOpen}
                   toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <div>
                <Label>
                    {_.get(this.props.translation, 'accreditation_requests.reject_accreditation_requests_alert')}
                </Label>
                <div className="modal-buttons-container">
                    <Button color="secondary"
                            onClick={this.handleCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="carrot-red-btn"
                            onClick={this.handleReject}>{_.get(this.props.translation, "accreditation_requests.reject_button")}</Button>
                </div>
            </div>
        );
    }

    handleReject = (e) => {
        e.preventDefault();

        this.props.onReject();
        this.props.onCancel();
    };

    handleCancel = () => {
        this.props.onCancel();
    };
}

RejectAccreditationRequestsByGroupModal.propTypes = {
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onReject: PropTypes.func,
    onCancel: PropTypes.func
};

export default RejectAccreditationRequestsByGroupModal;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationModal/rejectAccreditationRequestsByGroupModal/RejectAccreditationRequestsByGroupModal.js